module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"criticity":"Deviation assessed","followed":"Followed","resolved":"Resolved","standardized":"Standardized"},"fr":{"criticity":"Ecart évalué","followed":"Suivi","resolved":"Résolu","standardized":"Standardisé"}}')
  delete Component.options._Ctor
}
